export default __webpack_public_path__ + "static/media/pp (3).baaf5ebf.jpg";